<template>
  <div class="card gl-item">
    <div v-if="imageUrl" class="card-image">
      <figure class="image">
        <a :href="product.url"><img :src="imageUrl" alt=""></a>
      </figure>
    </div>

    <div class="card-content">
      <div class="content">
        <div class="product-title"><a class="title is-5" :href="product.url">{{product.name}}</a></div>

        <div>
          <p>{{product.short_description}}</p>
          <p v-if="minPrice">от <b>{{numeral(minPrice).format('0.00 $')}}</b></p>
        </div>

        <div>
          <small>артикул: {{product.code}}</small>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'lodash'
  import { numeral } from 'glonass/core/global'

  /**
   * Элемент в списке товаров.
   */
  export default {
    name: 'product-item',

    props: {
      product: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        numeral
      }
    },

    computed: {
      imageUrl () {
        return _.get(this.product, 'media.data.images[0].medium')
      },

      minPrice () {
        if (_.has(this.product, 'offers.data')) {
          return _.minBy(this.product.offers.data, 'price')['price']
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .gl-item {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// Item.vue?439743cd